import React, { FC, useState } from 'react';
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';
import { FormProvider, useForm, useWatch } from 'react-hook-form';

import { ButtonTypes } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';

import { KvitteringInfoWeb, TilbakemeldingTypeWeb, ValgtWeb } from '../../generated-types';
import { useSaveTilbakemelding } from '../../hooks/useTilbakemelding';
import { useTranslation } from '../../translations';
import { TilbakemeldingFormData } from './kvittering';
import TilbakemeldingKommentar from './tilbakemeldingKommentar';
import TilbakemeldingTakk from './tilbakemeldingTakk';
import TilbakemeldingValg from './tilbakemeldingValg';

interface Props {
    kvitteringInfo: KvitteringInfoWeb | undefined;
}

const Tilbakemelding: FC<Props> = ({ kvitteringInfo }) => {
    const { kvittering, button } = useTranslation();
    const [visTakk, setVisTakk] = useState<boolean>(false);
    const { mutate: saveTilbakemelding, isPending: saving } = useSaveTilbakemelding(() => {
        setVisTakk(true);
    });
    const methods = useForm<TilbakemeldingFormData>({ defaultValues: { tilbakemeldingValg: ValgtWeb.IKKE_VALGT } });
    const { control, handleSubmit } = methods;
    const tilbakemeldingValg = useWatch({ name: 'tilbakemeldingValg', control });

    const onSubmitTilbakemelding = (data: TilbakemeldingFormData) => {
        if (kvitteringInfo) {
            saveTilbakemelding({
                soeknadId: kvitteringInfo.soeknadId,
                soeknadstype: kvitteringInfo?.soeknadstype,
                type:
                    data.tilbakemeldingValg === ValgtWeb.JA
                        ? TilbakemeldingTypeWeb.POSITIV
                        : TilbakemeldingTypeWeb.NEGATIV,
                kommentar: data.kommentar,
                os: `${osName} ${osVersion}`,
                browser: `${browserName} ${browserVersion}`,
            });
        }
    };

    return (
        <FormProvider {...methods}>
            <form className="form-box-grey">
                {!visTakk && (
                    <>
                        <h3 className="title">{kvittering.titleTilbakemelding}</h3>
                        <span>{kvittering.paragrafTilbakemelding}</span>
                        <TilbakemeldingValg />
                        {tilbakemeldingValg !== ValgtWeb.IKKE_VALGT && (
                            <>
                                <TilbakemeldingKommentar />
                                <div className="column justify-content-center">
                                    <ButtonWithSpinner
                                        type="button"
                                        buttonType={ButtonTypes.STANDARD_POSITIVE}
                                        showSpinner={saving}
                                        onClick={handleSubmit(onSubmitTilbakemelding)}
                                    >
                                        {button.send}
                                    </ButtonWithSpinner>
                                </div>
                            </>
                        )}
                    </>
                )}
                {visTakk && <TilbakemeldingTakk />}
            </form>
        </FormProvider>
    );
};

export default Tilbakemelding;
